import { FormControl, InputLabel, Select, MenuItem } from '@mui/material'
import React from 'react'
import _ from 'lodash'
import { localSelector, selectedLocationChangeFunction } from '../../../store/slices/local'
import { useDispatch, useSelector } from 'react-redux'
import { locationsSelector } from '../../../store/slices/location'
const LocationSelector = ({ }) => {
    const dispatch=useDispatch()
    const {selectedLocation, selectedCompany}=useSelector(localSelector)
    const {locations}=useSelector(locationsSelector)
    const setSelectedLocation=(locationId)=>{
        dispatch(selectedLocationChangeFunction(locationId))
    }
    const locationsMemo = React.useMemo(() =>
        _.chain(locations).clone()
            .uniqBy('locationId')
            .sortBy('name')
            .value(), [locations])
    const handleLocationChange = (event) => {
        setSelectedLocation(event.target.value);
    }
    return (
        <FormControl
            disabled={selectedCompany ? false : true}
            size="small"

            sx={{ width: '200px' }}
        >
            {/* <InputLabel sx={{ background: "white" }}>
                Select a Location
            </InputLabel> */}
            <Select
            size='small'
                value={selectedLocation}
                onChange={handleLocationChange}
                sx={{ minWidth: "180px" }}
            >
                <MenuItem value={"all"}>All</MenuItem>
                {_.map(locationsMemo, (location) => (
                    <MenuItem
                        key={location.locationId}
                        value={location.locationId}
                    >
                        {location.name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    )
}

export default LocationSelector